import React, { useState, useEffect } from 'react';  
import axios from "axios"; 
import Spinner from '../../../../components/common/Spinner';
import CookieBar from './CookieBar';
import Cookies from "js-cookie";

const Footer = () => {
 
    const [loginModal, setLoginModal] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [disclaimer, SetDisclaimer] = useState(false);
    const year = new Date().getFullYear();

    useEffect(() => { 
        const disclaim = Cookies.get('disclaimerConsent');
        if(disclaim === undefined) {
            SetDisclaimer(true);
        }
    }, []);

    const handleLoginModal = () => { 
        setLoginModal(true); 
    }
 

    return ( 
            <footer className="doc_footer_area">
            {loginModal ? <div className="cover"><Spinner
                        size={80}
                        color="#4fa94d"
                        center={true}
                        /> </div> : ""} 
                <div className="doc_footer_bottom">
                    <div className="container">
                        <div className='row'>
                            <div className='col-md-9'>
                            <ul className="doc_footer_menu list-unstyled wow fadeInUp" data-wow-delay="0.2s">
                                <li><a href="/">Home</a></li> 
                                {/* <li><a onClick={handleLoginModal} href={window.base_url + "login"}>Login</a></li>  */}
                                 <li><a onClick={handleLoginModal} href="/login">Login</a></li> 
                                <li><a href="https://silulumanzi.com">Silulumanzi Website</a></li>
                            </ul>
                            </div>
                            <div className='col-md-3'>
                                <p className="wow fadeInUp" data-wow-delay="0.3s">© {year} Silulumanzi <span></span></p>
                            </div>
                        </div>                        
                    </div>
                </div>

                {disclaimer ? <CookieBar/>:<></>}
            </footer> 
        );
    }

    

export default Footer;